import { DefinedPropertyObject, IEntityMinimalModel } from "../../api/GenericTypes";
import { EntityFilterSideBar } from "../../common/sidebar/filtersidebar/EntityFilterBar";
import { Method, MethodFilters } from "../../api/Method";
import { DataFormatsVirtualizedSelectForm } from "../../common/forms/EntityForms/formsVirtualized/DataFormatsVirtualizedSelectForm";
import {
  TabStoreFilterSidebarProps,
  TabStoreFilterFormProvider,
} from "../../common/sidebar/filtersidebar/TabStoreFilterFormProvider";

export interface MethodFilterForm {
  formatIds?: IEntityMinimalModel<string>[] | undefined | null;
}
const defaultValues: DefinedPropertyObject<MethodFilterForm> = {
  formatIds: null,
};
const formToFilters = (form: MethodFilterForm): MethodFilters => {
  let filters: MethodFilters = {};
  filters.dataFormatIds =
    Array.isArray(form.formatIds) && form.formatIds.length > 0 ? form.formatIds.map((d) => d.id) : null;
  return filters;
};
const defaultFilters: MethodFilters = { sortBy: [{ property: "NAME", sortDirection: "ASC" }] };

export const MethodFilterBar = ({
  initialValues,
  setFilters,
  dispatchTabStore,
  onFormChange,
  tabsLoading,
}: TabStoreFilterSidebarProps<Method, MethodFilterForm, MethodFilters>) => {
  return (
    <TabStoreFilterFormProvider
      tabsLoading={tabsLoading}
      initialValues={initialValues}
      defaultValues={defaultValues}
      defaultFilters={defaultFilters}
      formToFilters={formToFilters}
      onFormChange={onFormChange}
      dispatchTabStore={dispatchTabStore}
      setFilters={setFilters}
    >
      {({ control, onReset }) => (
        <EntityFilterSideBar onReset={onReset}>
          <DataFormatsVirtualizedSelectForm id="formatIds" control={control} horizontal={false} isMulti />
        </EntityFilterSideBar>
      )}
    </TabStoreFilterFormProvider>
  );
};
